// extracted by mini-css-extract-plugin
module.exports =  {"text":"_0d624b9a27--text--b4byr","title":"_0d624b9a27--title--jZcU2"};